import { Space } from "antd";
import React from "react";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import tmsRouteMap from "../../../constants/tms-route.map";
import TmsAccommodationService from "../../../services/tms-accommodation.service";

const TmsAccManageRoomCategoryActions = ({
  record,
  setLoading,
  setViewAccommodationData,
  settmsModalVisible,
  // eslint-disable-next-line no-unused-vars
  setUpdateFlag,
  setEditFlag,
  setRoomCategorytId,
  blockID,
  router,
}) => {
  return (
    <Space size="middle">
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sm_acc_mrc_manage_quota}?id=${blockID}&categoryid=${record.key}`
          );
        }}
      >
        Manage Quota
      </a>
      <a
        onClick={() => {
          router.navigate(
            `${tmsRouteMap.sm_acc_mrc_manage_room}?id=${blockID}&categoryid=${record.key}`
          );
        }}
      >
        Manage Room
      </a>

      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsAccommodationService.getBlockCategoryById(
              record?.key
            );
            // console.log(darData);
            setViewAccommodationData(darData);
            settmsModalVisible(true);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EyeOutlined />
      </a>
      {/* <Popconfirm
        title="Are you sure delete this darshanam?"
        onConfirm={async () => {
          setLoading(true);
          try {
            await TmsDarshanamService.deleteDarshanam(record?.key);
            notification.success({
              message: "Darshanam Deleted Successful",
            });
            setUpdateFlag(Math.Random + 1);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
        okText="Yes"
        cancelText="No"
      >
        <a>
          <DeleteOutlined />
        </a>
      </Popconfirm> */}
      <a
        onClick={async () => {
          setLoading(true);
          try {
            const darData = await TmsAccommodationService.getBlockCategoryById(
              record?.key
            );
            setViewAccommodationData(darData);
            settmsModalVisible(true);
            setEditFlag(true);
            setRoomCategorytId(record?.key);
          } catch (error) {
            catchErrorFunction(
              error,
              "Token Expired, redirecting to login page in 5 seconds",
              router
            );
          }
          setLoading(false);
        }}
      >
        <EditOutlined />
      </a>
    </Space>
  );
};
export default withRouter(TmsAccManageRoomCategoryActions);
